"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeSeriesBarChartPropTypes = exports.AXIS_TYPES = void 0;
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const react_resize_detector_1 = require("react-resize-detector");
const Axis_1 = __importDefault(require("../../components/Axis"));
const Bars_1 = __importDefault(require("../../components/Bars"));
const Gridlines_1 = __importStar(require("../../components/Gridlines"));
const Tooltip_1 = __importStar(require("../../components/Tooltip"));
const TooltipContent_1 = __importDefault(require("../../components/Tooltip/TooltipContent"));
const utilities_1 = require("../../utilities");
const colors_1 = require("../../utilities/colors");
const date_1 = require("../../utilities/date");
const format_1 = require("../../utilities/format");
const measurements_1 = require("../../utilities/measurements");
const constants_1 = require("./constants");
const helpers_1 = require("./helpers");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
exports.AXIS_TYPES = (0, lodash_1.default)(format_1.VALUE_FORMATS).omit(['default']).keys().value();
const TOOLTIP_DIRECTION_OFFSET = 10;
const TOOLTIP_DIRECTION_Y_MIN = 100;
const TimeSeriesBarChart = _ref => {
  let {
    barOptions = constants_1.DEFAULT_BAR_OPTIONS,
    data: rawData,
    height = constants_1.DEFAULT_HEIGHT,
    onClick,
    onMouseOut,
    onMouseOver,
    tooltipOptions = constants_1.DEFAULT_TOOLTIP_OPTIONS,
    xAxisOptions = constants_1.DEFAULT_X_AXIS_OPTIONS,
    yAxisOptions = constants_1.DEFAULT_Y_AXIS_OPTIONS
  } = _ref;
  /** Initialize options */
  const optsBar = lodash_1.default.defaultsDeep({}, barOptions, constants_1.DEFAULT_BAR_OPTIONS);
  const optsTooltip = lodash_1.default.defaultsDeep({}, tooltipOptions, constants_1.DEFAULT_TOOLTIP_OPTIONS);
  const optsXAxis = lodash_1.default.defaultsDeep({}, xAxisOptions, constants_1.DEFAULT_X_AXIS_OPTIONS);
  const optsYAxis = lodash_1.default.defaultsDeep({}, yAxisOptions, constants_1.DEFAULT_Y_AXIS_OPTIONS);
  /** State and vars */
  const barsRef = (0, react_1.useRef)([]);
  const chartHeightRef = (0, react_1.useRef)(0);
  const [tooltip, setTooltip] = (0, react_1.useState)(null);
  const optsBarValuesString = Object.values(optsBar).join();
  const optsXAxisValuesString = Object.values(optsXAxis).join();
  const optsYAxisValuesString = Object.values(optsYAxis).join();
  /** Prepare Component Data */
  const {
    data,
    xType,
    xDomain,
    xAxisFormat,
    yType,
    yDomain,
    yAxisFormat,
    hasCustomXDomain,
    hasCustomYDomain
  } = (0, react_1.useMemo)(() => {
    const dataKeys = ['id', 'data', 'name', 'x_type', 'y_type'];
    if (!rawData || dataKeys.some(i => !lodash_1.default.has(rawData, i))) {
      return {};
    }
    /** Extract and format data */
    const pickedData = lodash_1.default.pick({
      data: [],
      ...rawData
    }, [...dataKeys, 'tooltipTitle']);
    const finiteKVP = pickedData.data.filter(function () {
      let {
        value
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Number.isFinite(value);
    });
    const formattedKVP = (0, utilities_1.extractKeys)([{
      ...pickedData,
      data: finiteKVP
    }], date_1.dateParser).map(i => {
      const {
        value
      } = finiteKVP.find(j => j.key === i.key);
      return {
        ...i,
        value
      };
    }).sort((a, b) => a.formatted < b.formatted ? -1 : 1);
    /** Prepare X data */
    const xType = (0, utilities_1.isValidAxisType)(optsXAxis.type) ? optsXAxis.type : (0, utilities_1.getAxisTypeFromData)([pickedData], 'x') || constants_1.DEFAULT_X_TYPE;
    const xAxisFormat = (0, utilities_1.valueFormat)({
      params: {
        format: xType
      }
    });
    const hasCustomXDomain = [optsXAxis.displayRangeMin, optsXAxis.displayRangeMax].some(cd => cd !== undefined);
    const xDomain = [optsXAxis.displayRangeMin ? (0, date_1.dateParser)(optsXAxis.displayRangeMin, xType) : lodash_1.default.first(formattedKVP).formatted, optsXAxis.displayRangeMax ? (0, date_1.dateParser)(optsXAxis.displayRangeMax, xType) : lodash_1.default.last(formattedKVP).formatted];
    // custom ticks and not custom domain, remove out of bound ticks
    if (optsXAxis.ticks && !hasCustomXDomain) {
      xDomain[0] = lodash_1.default.min([xDomain[0], (0, date_1.dateParser)(optsXAxis.ticks[0], xType)]);
      xDomain[1] = lodash_1.default.max([xDomain[1], (0, date_1.dateParser)(lodash_1.default.last(optsXAxis.ticks), xType)]);
    }
    /** Prepare Y data */
    const yType = (0, utilities_1.isValidAxisType)(optsYAxis.type) ? optsYAxis.type : (0, utilities_1.getAxisTypeFromData)([pickedData], 'y') || constants_1.DEFAULT_Y_TYPE;
    const yAxisFormat = (0, utilities_1.valueFormat)({
      params: {
        format: yType
      }
    });
    const values = formattedKVP.map(_ref2 => {
      let {
        value
      } = _ref2;
      return value;
    });
    const yDomain = [optsYAxis.displayRangeMin || lodash_1.default.min(values), optsYAxis.displayRangeMax || lodash_1.default.max(values)];
    if (!optsYAxis.displayRangeMin && values.every(v => v >= 0)) {
      yDomain[0] = 0;
    }
    if (!optsYAxis.displayRangeMax && values.every(v => v <= 0)) {
      yDomain[1] = 0;
    }
    // custom ticks and not custom domain, remove out of bound ticks
    const hasCustomYDomain = [optsYAxis.displayRangeMin, optsYAxis.displayRangeMax].some(cd => cd !== undefined);
    if (optsYAxis.ticks && !hasCustomYDomain) {
      yDomain[0] = lodash_1.default.min([yDomain[0], optsYAxis.ticks[0]]);
      yDomain[1] = lodash_1.default.max([yDomain[1], lodash_1.default.last(optsYAxis.ticks)]);
    }
    // Add formatted kvp back into data
    const filteredKVP = formattedKVP.filter(_ref3 => {
      let {
        formatted,
        value
      } = _ref3;
      if (formatted < xDomain[0] || formatted > xDomain[1]) {
        return false;
      }
      if (value < yDomain[0] || value > yDomain[1]) {
        return false;
      }
      return true;
    });
    const {
      color,
      negativeColor
    } = filteredKVP.reduce((_ref4, k, i) => {
      let {
        color,
        negativeColor
      } = _ref4;
      if (lodash_1.default.isArray(optsBar.color)) {
        color.push((0, colors_1.parseColor)(optsBar.color[i], colors_1.DEFAULT_COLORS[i] || colors_1.DEFAULT_COLORS[0]));
      } else {
        color.push((0, colors_1.parseColor)(optsBar.color, colors_1.DEFAULT_COLORS[0]));
      }
      if (lodash_1.default.isArray(optsBar.negativeColor)) {
        negativeColor.push((0, colors_1.parseColor)(optsBar.negativeColor[i], colors_1.DEFAULT_COLORS[i + 1] || colors_1.DEFAULT_COLORS[1]));
      } else {
        negativeColor.push((0, colors_1.parseColor)(optsBar.negativeColor, colors_1.DEFAULT_COLORS[1]));
      }
      return {
        color,
        negativeColor
      };
    }, {
      color: [],
      negativeColor: []
    });
    const data = {
      ...pickedData,
      data: filteredKVP,
      tooltipTitle: pickedData.tooltipTitle || pickedData.name,
      color,
      negativeColor
    };
    return {
      data,
      xType,
      xDomain,
      xAxisFormat,
      yType,
      yDomain,
      yAxisFormat,
      hasCustomXDomain,
      hasCustomYDomain
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawData === null || rawData === void 0 ? void 0 : rawData.id, optsBarValuesString, optsXAxisValuesString, optsYAxisValuesString]);
  const onBarMouseOver = (0, react_1.useCallback)((e, barIndex) => {
    const datum = data.data[barIndex];
    const bar = barsRef.current[barIndex];
    if (!datum || !bar) {
      return;
    }
    let direction = optsTooltip.position;
    let {
      y
    } = bar;
    if (optsTooltip.position === 'above') {
      y += constants_1.DEFAULT_TOOLTIP_PADDING * -1;
      if (bar.y < TOOLTIP_DIRECTION_Y_MIN) {
        direction = 'below';
        y = bar.y + TOOLTIP_DIRECTION_OFFSET;
      }
    } else if (optsTooltip.position === 'below') {
      y += bar.height + constants_1.DEFAULT_TOOLTIP_PADDING;
      if (bar.y + bar.height > chartHeightRef.current - TOOLTIP_DIRECTION_Y_MIN) {
        direction = 'above';
        y = bar.y + bar.height - TOOLTIP_DIRECTION_OFFSET;
      }
    }
    setTooltip({
      position: {
        x: bar.x + bar.width / 2,
        y
      },
      value: datum.value,
      direction,
      title: data.tooltipTitle || data.name,
      color: datum.value < 0 ? data.negativeColor[barIndex] : data.color[barIndex],
      label: xAxisFormat(datum.key),
      type: data.y_type
    });
    if (typeof onMouseOver === 'function') {
      onMouseOver(e, barIndex, datum);
    }
  }, [data, onMouseOver, optsTooltip, xAxisFormat]);
  const onBarMouseOut = (0, react_1.useCallback)((e, barIndex) => {
    if (tooltip) {
      setTooltip(null);
    }
    const datum = data.data[barIndex];
    if (!datum) {
      return;
    }
    if (typeof onMouseOut === 'function') {
      onMouseOut(e, barIndex, datum);
    }
  }, [data, tooltip, onMouseOut]);
  const onBarClick = (0, react_1.useCallback)((e, barIndex) => {
    const datum = data.data[barIndex];
    if (!datum) {
      return;
    }
    if (typeof onClick === 'function') {
      onClick(e, barIndex, datum);
    }
  }, [data, onClick]);
  const ref = (0, react_1.useRef)();
  const {
    width: chartWidth = 1,
    height: resizedHeight = parseInt(height, 10)
  } = (0, react_resize_detector_1.useResizeDetector)({
    targetRef: ref,
    refreshMode: 'debounce',
    refreshRate: 250,
    refreshOptions: {
      leading: false,
      trailing: true
    }
  });
  if (!data || !data.data.length) {
    console.warn('No data was provided.');
    return null;
  }
  const chartHeight = height ? parseInt(height, 10) : resizedHeight;
  const topAxisHeight = (lodash_1.default.includes(optsXAxis.displayTicks, constants_1.AXIS_POSITIONS.top) ? optsXAxis.fontSize : 0) * 1.2;
  const bottomAxisHeight = (lodash_1.default.includes(optsXAxis.displayTicks, constants_1.AXIS_POSITIONS.bottom) ? optsXAxis.fontSize : 0) * 1.2;
  const yRange = [chartHeight - bottomAxisHeight - constants_1.DEFAULT_CHART_Y_PADDING, topAxisHeight + constants_1.DEFAULT_CHART_Y_PADDING];
  const {
    ticks: yTicks,
    scale: yScale
  } = (0, helpers_1.createYAxis)({
    type: yType,
    range: yRange,
    domain: yDomain,
    hasCustomDomain: hasCustomYDomain,
    customTicks: optsYAxis.ticks
  });
  // Now X axis
  const yAxisWidth = lodash_1.default.max(yTicks.map(i => (0, measurements_1.textDimensions)({
    text: yAxisFormat(i),
    fontSize: optsYAxis.fontSize
  }).width));
  const leftAxisWidth = lodash_1.default.includes(optsYAxis.displayTicks, constants_1.AXIS_POSITIONS.left) ? yAxisWidth : 0;
  const rightAxisWidth = lodash_1.default.includes(optsYAxis.displayTicks, constants_1.AXIS_POSITIONS.right) ? yAxisWidth : 0;
  const xRange = [leftAxisWidth + constants_1.DEFAULT_CHART_X_PADDING, chartWidth - rightAxisWidth - constants_1.DEFAULT_CHART_X_PADDING];
  const {
    scale: barScale
  } = (0, helpers_1.createBarScale)({
    type: xType,
    data,
    range: xRange,
    spacing: optsBar.spacing
  });
  const barWidth = barScale.bandwidth();
  const {
    ticks: xTicks,
    scale: xScale
  } = (0, helpers_1.createXAxis)({
    type: xType,
    range: [barScale(lodash_1.default.first(data.data).formatted) + barWidth / 2, barScale(lodash_1.default.last(data.data).formatted) + barWidth / 2],
    domain: xDomain,
    hasCustomDomain: hasCustomXDomain,
    customTicks: optsXAxis.ticks
  });
  const valuesCrossZero = yScale.domain()[0] < 0 && yScale.domain()[1] > 0;
  const bars = (0, helpers_1.calculateBars)({
    data,
    barScale,
    yScale
  });
  barsRef.current = bars;
  chartHeightRef.current = chartHeight;
  return react_1.default.createElement("div", {
    ref: ref,
    className: styles_module_css_1.default['time-series-bar-chart']
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['chart-container'],
    style: {
      height: chartHeight
    }
  }, react_1.default.createElement("svg", {
    style: {
      overflow: 'visible',
      height: chartHeight,
      flex: 1
    }
  }, (0, lodash_1.default)(constants_1.AXIS_POSITIONS).pick([constants_1.AXIS_POSITIONS.top, constants_1.AXIS_POSITIONS.bottom]).values().intersection(optsXAxis.displayTicks).value().map(position => react_1.default.createElement(Axis_1.default, {
    key: position,
    position: position,
    chartWidth: chartWidth,
    chartHeight: chartHeight,
    fontSize: optsXAxis.fontSize,
    textColor: (0, colors_1.parseColor)(optsXAxis.textColor, constants_1.DEFAULT_TEXT_COLOR),
    ticks: xTicks.map(tick => ({
      data: tick,
      point: xScale(tick)
    })),
    formatter: v => xAxisFormat(new Date(v), {
      ticks: xTicks
    })
  })), (0, lodash_1.default)(constants_1.AXIS_POSITIONS).pick([constants_1.AXIS_POSITIONS.left, constants_1.AXIS_POSITIONS.right]).values().intersection(optsYAxis.displayTicks).value().map(position => react_1.default.createElement(Axis_1.default, {
    key: position,
    position: position,
    chartWidth: chartWidth,
    chartHeight: chartHeight,
    fontSize: optsYAxis.fontSize,
    textColor: (0, colors_1.parseColor)(optsYAxis.textColor, constants_1.DEFAULT_TEXT_COLOR),
    ticks: yTicks.map(tick => ({
      data: tick,
      point: yScale(tick)
    })),
    formatter: v => yAxisFormat(v, {
      ticks: yTicks
    })
  })), (optsXAxis.showGridlines || valuesCrossZero) && react_1.default.createElement(Gridlines_1.default, {
    orientation: Gridlines_1.AXIS_ORIENTATIONS.vertical,
    range: yScale.range(),
    strokeWidth: 1,
    gridColor: colors_1.AXIS_LINE_COLOR,
    ticks: xTicks.filter(tick => optsXAxis.showGridlines || tick === 0).map(tick => ({
      point: xScale(tick)
    }))
  }), (optsYAxis.showGridlines || valuesCrossZero) && react_1.default.createElement(Gridlines_1.default, {
    orientation: Gridlines_1.AXIS_ORIENTATIONS.horizontal,
    range: xRange,
    strokeWidth: 1,
    gridColor: colors_1.AXIS_LINE_COLOR,
    ticks: yTicks.filter(tick => optsYAxis.showGridlines || tick === 0).map(tick => ({
      point: yScale(tick),
      strokeWidth: valuesCrossZero && tick === 0 && optsYAxis.showGridlines ? 3 : 1
      // && optsYAxis.showGridlines ? 'gray' : undefined
    }))
  }), react_1.default.createElement(Bars_1.default, {
    bars: bars,
    onMouseOver: onBarMouseOver,
    onMouseOut: onBarMouseOut,
    onClick: onBarClick
  })), optsTooltip.show && tooltip && react_1.default.createElement("div", {
    className: "tooltip-container"
  }, react_1.default.createElement(Tooltip_1.default, {
    direction: tooltip.direction,
    x: tooltip.position.x,
    y: tooltip.position.y,
    width: chartWidth
  }, react_1.default.createElement(TooltipContent_1.default, {
    title: tooltip.title,
    subtitle: optsTooltip.showSubtitle ? tooltip.label : undefined,
    value: tooltip.value,
    color: tooltip.color,
    decimals: optsTooltip.decimals,
    type: tooltip.type
  })))));
};
exports.TimeSeriesBarChartPropTypes = {
  /**
   * Configuration options for bars
   * @param color {string} color to be used for all bars, if not set a default color will be used
   * @param spacing {number} height of each bar
   * @param negativeColor {string} color to be used for all negative value bars, if not set a default color will be used
   */
  barOptions: (0, prop_types_1.shape)({
    color: (0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.arrayOf)(prop_types_1.string)]),
    spacing: prop_types_1.number,
    negativeColor: (0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.arrayOf)(prop_types_1.string)])
  }),
  /**
   * Data for the chart.
   * @param data {object[]} array of data to be displayed { key, value }
   * @param id {string} unique identifier
   * @param name {string} name/label of the data
   * @param tooltipTitle {string} overwrite name on tooltip
   * @param x_type {string} key type - 'items','linear','unformatted','percent','dollars','years',
   * 	'yearly','months','monthly','quarters','quarterly','weeks','weekly','days','daily'
   * @param y_type {string} value type - 'items','linear','unformatted','percent','dollars','years',
   * 	'yearly','months','monthly','quarters','quarterly','weeks','weekly','days','daily'
   */
  data: (0, prop_types_1.shape)({
    data: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
      key: prop_types_1.string.isRequired,
      value: prop_types_1.number // Not required since we allow nulls
    })).isRequired,
    id: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]).isRequired,
    name: prop_types_1.string.isRequired,
    tooltipTitle: prop_types_1.string,
    x_type: prop_types_1.string,
    y_type: prop_types_1.string
  }).isRequired,
  /** height of chart */
  height: prop_types_1.number,
  /**
   * Configuration options for tooltips
   * @param decimals {number} decimals to show on tooltip
   * @param position {string} if the tooltip is above or below the bar - 'above' or 'below'
   * @param show {bool} show or hide tooltips
   * @param showSubtitle {bool} show or hide tooltip subtitles
   */
  tooltipOptions: (0, prop_types_1.shape)({
    decimals: prop_types_1.number,
    position: (0, prop_types_1.oneOf)(Tooltip_1.TOOLTIP_POSITIONS),
    show: prop_types_1.bool,
    showSubtitle: prop_types_1.bool
  }),
  /** length of transitions in ms */
  transitionDuration: prop_types_1.number,
  /**
   * Configuration options for the xAxis
   * @param displayRangeMin {number,string} domain minimum to be used for the axis
   * @param displayRangeMax {number,string} domain maximum to be used for the axis
   * @param displayTicks {string[]} what positions to display axis - 'top','bottom'
   * @param fontSize {number} font size of axis text
   * @param showGridlines {bool} show or hide gridlines
   * @param textColor {string} axis label color
   * @param ticks {number[], string[]} custom ticks for the axis
   * @param type {string} data type - 'items','linear','unformatted','percent','dollars','years',
   * 'yearly','months','monthly','quarters','quarterly','weeks','weekly','days','daily'
   */
  xAxisOptions: (0, prop_types_1.shape)({
    displayRangeMax: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    displayRangeMin: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    displayTicks: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOf)(lodash_1.default.values(constants_1.AXIS_POSITIONS))),
    fontSize: prop_types_1.number,
    showGridlines: prop_types_1.bool,
    textColor: prop_types_1.string,
    ticks: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string])),
    type: (0, prop_types_1.oneOf)(exports.AXIS_TYPES)
  }),
  /**
   * Configuration options for the yAxis
   * @param decimals {number} decimals to show on xAxis
   * @param displayRangeMin {number,string} domain minimum to be used for the axis
   * @param displayRangeMax {number,string} domain maximum to be used for the axis
   * @param displayTicks {string[]} what positions to display axis - 'top','bottom'
   * @param fontSize {number} font size of axis text
   * @param showGridlines {bool} show or hide gridlines
   * @param ticks {number[], string[]} custom ticks for the axis
   * @param type {string} data type - 'items','linear','unformatted','percent','dollars','years',
   * 'yearly','months','monthly','quarters','quarterly','weeks','weekly','days','daily'
   * @param textColor {string} axis label color
   */
  yAxisOptions: (0, prop_types_1.shape)({
    decimals: prop_types_1.number,
    displayRangeMax: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    displayRangeMin: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    displayTicks: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOf)(lodash_1.default.values(constants_1.AXIS_POSITIONS))),
    fontSize: prop_types_1.number,
    showGridlines: prop_types_1.bool,
    textColor: prop_types_1.string,
    ticks: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string])),
    type: (0, prop_types_1.oneOf)(exports.AXIS_TYPES)
  }),
  /** On bar mouse over event (event, dataIndex, data { key, formatted, value }) */
  onMouseOver: prop_types_1.func,
  /** On bar mouse out event (event, dataIndex, data ) */
  onMouseOut: prop_types_1.func,
  /** On bar click event (event, data { key, formatted, value }) */
  onClick: prop_types_1.func
};
TimeSeriesBarChart.propTypes = {
  ...exports.TimeSeriesBarChartPropTypes
};
exports.default = TimeSeriesBarChart;